import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import PersonAddForm from "../../components/Person/Add/PersonAddForm";
import { Grid } from "@material-ui/core";

const PersonAdminAddPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp title={"افزودن مدیر"} />

      <Grid container={true}>
        <Grid item xs={12}>
          <PersonAddForm isAdmin={true} />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default PersonAdminAddPage;
